import { Action, combineReducers } from "redux";
import { ICompanyGroupPage } from "source/models/companyGroup/companyGroupPage";

// State
export interface ICompanyGroupPageState {
    dataId: number;
    companyGroupPage: ICompanyGroupPage;
}

export interface ICompanyGroupState {
    page: ICompanyGroupPageState;
}

// Action type constants
const COMPANYGROUP_SUCCESS = "COMPANYGROUP_SUCCESS";
const COMPANYGROUP_FAILURE = "COMPANYGROUP_FAILURE";

type T_COMPANYGROUP_SUCCESS = typeof COMPANYGROUP_SUCCESS;
type T_COMPANYGROUP_FAILURE = typeof COMPANYGROUP_FAILURE;

// Action types
interface ICompanyGroupSuccess extends Action {
    type: T_COMPANYGROUP_SUCCESS;
    companyGroupPage: ICompanyGroupPage;
}

interface ICompanyGroupFailure extends Action {
    type: T_COMPANYGROUP_FAILURE;
}

export type CompanyGroupAction =
    | ICompanyGroupSuccess
    | ICompanyGroupFailure;

//Actions
export const companyGroupSuccess = (companyGroupPage: ICompanyGroupPage): ICompanyGroupSuccess => ({
    type: COMPANYGROUP_SUCCESS,
    companyGroupPage
});

export const companyGroupFailure = (): ICompanyGroupFailure => ({
    type: COMPANYGROUP_FAILURE
});

//Reducers
export const companyGroupInitialState: ICompanyGroupState = {
    page: {
        dataId: 0,
        companyGroupPage: null
    }
};

const page = (state: ICompanyGroupPageState = null, action: CompanyGroupAction) => {
    switch (action.type) {
    case COMPANYGROUP_SUCCESS: {
        const companyGroupSuccess = action as ICompanyGroupSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            companyGroupPage: companyGroupSuccess.companyGroupPage
        };
    }
    case COMPANYGROUP_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const companyGroupReducer = combineReducers({
    page,
});

//Utils